import { useState } from "react";
import { FaSearch } from "react-icons/fa";

import "../styles/hero.css";

function Hero() {
  const [search, setSearch] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();

    console.log(search);

    // We'll connect this to the backend later.
  };

  return (
    <section className="hero">

      <div className="hero-overlay">

        <div className="hero-content">

          <h1>
            Find Past Papers, CATs & Exams
          </h1>

          <p>
            Search thousands of university,
            college and professional examination
            papers in one place.
          </p>

          <form
            className="hero-search"
            onSubmit={handleSearch}
          >

            <div className="search-box">

              <FaSearch className="search-icon" />

              <input
                type="text"
                placeholder="Search exams, units or categories..."
                value={search}
                onChange={(e) =>
                  setSearch(e.target.value)
                }
              />

            </div>

            <button type="submit">
              Search
            </button>

          </form>

        </div>

      </div>

    </section>
  );
}

export default Hero;